/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macro Calculator (Protein, Carbs, Fat) — Toolverse`)
};

const es_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Macros (Proteína, Carbohidratos, Grasa) — Toolverse`)
};

const de_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makro-Rechner (Protein, Kohlenhydrate, Fett) — Toolverse`)
};

const nl_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macro Calculator (Eiwit, Koolhydraten, Vet) — Toolverse`)
};

const fr_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Macros (Protéines, Glucides, Lipides) — Toolverse`)
};

const it_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di macronutrienti (proteine, carboidrati, grassi) — Toolverse`)
};

const pt_br2_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Macros (Proteína, Carboidrato, Gordura) — Toolverse`)
};

const pt_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Macros (Proteína, Hidratos, Gordura) — Toolverse`)
};

const ja_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マクロ計算機(タンパク質・炭水化物・脂質) — Toolverse`)
};

const zh_macro_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三大营养素计算器（蛋白质、碳水、脂肪）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_meta_title", locale)
	if (locale === "en") return en_macro_meta_title(inputs)
	if (locale === "es") return es_macro_meta_title(inputs)
	if (locale === "de") return de_macro_meta_title(inputs)
	if (locale === "nl") return nl_macro_meta_title(inputs)
	if (locale === "fr") return fr_macro_meta_title(inputs)
	if (locale === "it") return it_macro_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_macro_meta_title(inputs)
	if (locale === "pt") return pt_macro_meta_title(inputs)
	if (locale === "ja") return ja_macro_meta_title(inputs)
	return zh_macro_meta_title(inputs)
};